var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _c(
      "div",
      {
        staticClass: "collapse show",
        attrs: {
          id: "collapseOne",
          "aria-labelledby": "headingOne",
          "data-parent": "#accordion"
        }
      },
      [
        _c("div", { staticClass: "card-body compact-padding" }, [
          _c("div", { staticClass: "default-padding" }, [
            _c("div", { staticClass: "form-row" }, [
              _c("div", { staticClass: "form-group col-md-6" }, [
                _c("label", [_vm._v("เลขที่หนังสือค้ำประกันเดิม")]),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.contingent,
                      expression: "contingent"
                    }
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "" },
                  domProps: { value: _vm.contingent },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.contingent = $event.target.value
                    }
                  }
                })
              ]),
              _c("div", { staticClass: "form-group no-label col-md-3" }, [
                _c("label"),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-primary-ktb",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        return _vm.searchRequest()
                      }
                    }
                  },
                  [_vm._v("\n              ค้นหา\n            ")]
                )
              ])
            ])
          ])
        ]),
        this.appVo != null && this.appVo.requesterTaxId != null
          ? _c(
              "div",
              {
                staticClass: "collapse show",
                attrs: {
                  id: "collapseOne",
                  "aria-labelledby": "headingOne",
                  "data-parent": "#accordion"
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "card-body compact-padding" },
                  [
                    _c(
                      "div",
                      { staticClass: "default-padding" },
                      [
                        _c("div", { staticClass: "data-display mb-3" }, [
                          _c("table", { staticClass: "two-col-data" }, [
                            _c("tbody", [
                              _c("tr", [
                                _c("th", [_vm._v("Tax ID")]),
                                _c("td", { staticClass: "important" }, [
                                  _vm._v(_vm._s(_vm.appVo.requesterTaxId))
                                ])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("ชื่อลูกค้า (Th)")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.appVo.requesterNameTh))
                                ])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("ชื่อลูกค้า (En)")]),
                                _c("td", [
                                  _vm._v(_vm._s(_vm.appVo.requesterNameEn))
                                ])
                              ]),
                              _c("tr", [
                                _c("th", [_vm._v("ที่อยู่ลูกค้า")]),
                                _c("td", [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.appVo.requesterAddr) +
                                      "  " +
                                      _vm._s(_vm.appVo.requesterSubDistrict) +
                                      "  " +
                                      _vm._s(_vm.appVo.requesterDistrict) +
                                      "  " +
                                      _vm._s(_vm.appVo.requesterProvince) +
                                      "  " +
                                      _vm._s(_vm.appVo.requesterZipcode) +
                                      "\n                  "
                                  )
                                ])
                              ])
                            ])
                          ])
                        ]),
                        _c("div", { staticClass: "form-row" }, [
                          _vm._m(1),
                          _c(
                            "div",
                            { staticClass: "form-group no-label col-md-7" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.appVo.beneNameTh) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _c("div", { staticClass: "form-row" }, [
                          _vm._m(2),
                          _c(
                            "div",
                            { staticClass: "form-group no-label col-md-7" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.appVo.contingentTypeName) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _c(
                          "div",
                          {
                            staticClass: "form-row",
                            class: { hideForm: _vm.isHideForm }
                          },
                          [
                            _vm._m(3),
                            this.appVo != null && this.appVo.modifyFlag === "Y"
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "form-group no-label col-md-7"
                                  },
                                  [
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.lgFormNoExtendTop,
                                            expression: "lgFormNoExtendTop"
                                          },
                                          {
                                            name: "validate",
                                            rawName: "v-validate",
                                            value: "required",
                                            expression: "'required'"
                                          }
                                        ],
                                        staticClass: "form-control",
                                        class: {
                                          input: true,
                                          "is-danger": _vm.errors.has(
                                            "lgFormNo"
                                          )
                                        },
                                        attrs: { name: "lgFormNo" },
                                        on: {
                                          change: function($event) {
                                            var $$selectedVal = Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function(o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function(o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                            _vm.lgFormNoExtendTop = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          }
                                        }
                                      },
                                      [
                                        _c("option", { attrs: { value: "" } }, [
                                          _vm._v("กรุณาเลือก")
                                        ]),
                                        _vm._l(_vm.lgFormList, function(
                                          option
                                        ) {
                                          return _c(
                                            "option",
                                            {
                                              key: option.lgFormNo,
                                              domProps: {
                                                value: option.lgFormNo
                                              }
                                            },
                                            [_vm._v(_vm._s(option.lgFormNo))]
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass: "form-group no-label col-md-7"
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.appVo.lgFormNo) +
                                        "\n            "
                                    )
                                  ]
                                )
                          ]
                        ),
                        _c("div", { staticClass: "form-row" }, [
                          _vm._m(4),
                          _c(
                            "div",
                            { staticClass: "form-group no-label col-md-7" },
                            [_vm._v(_vm._s(_vm.appVo.commNo))]
                          )
                        ]),
                        _c("div", { staticClass: "form-row" }, [
                          _vm._m(5),
                          _c(
                            "div",
                            { staticClass: "form-group no-label col-md-7" },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.formatPrice(_vm.appVo.lgAmt)) +
                                  "\n            "
                              )
                            ]
                          )
                        ]),
                        _vm.appVo != null &&
                        _vm.appVo.requesterList != null &&
                        _vm.appVo.requesterList.length > 0
                          ? _c("div", { staticClass: "option-form mb-4" }, [
                              _c("div", { staticClass: "form-group" }, [
                                _c("label", [_vm._v("เพื่อค้ำประกันในนาม")]),
                                this.appVo != null &&
                                (this.appVo.modifyFlag === "Y" ||
                                  this.lgGroup === "NHSO")
                                  ? _c(
                                      "div",
                                      [
                                        _c("b-table", {
                                          attrs: {
                                            striped: "",
                                            hover: "",
                                            items: _vm.appVo.requesterList,
                                            fields: _vm.fields
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "cell(guaranteeTaxId)",
                                                fn: function(row) {
                                                  return [
                                                    _c("b-form-input", {
                                                      attrs: { disabled: "" },
                                                      model: {
                                                        value:
                                                          row.item
                                                            .guaranteeTaxId,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "guaranteeTaxId",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.guaranteeTaxId"
                                                      }
                                                    })
                                                  ]
                                                }
                                              },
                                              {
                                                key: "cell(guaranteeName)",
                                                fn: function(row) {
                                                  return [
                                                    _c("b-form-input", {
                                                      model: {
                                                        value:
                                                          row.item
                                                            .guaranteeName,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "guaranteeName",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.guaranteeName"
                                                      }
                                                    })
                                                  ]
                                                }
                                              },
                                              {
                                                key: "cell(guaranteeNameEN)",
                                                fn: function(row) {
                                                  return [
                                                    _c("b-form-input", {
                                                      model: {
                                                        value:
                                                          row.item
                                                            .guaranteeNameEN,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            row.item,
                                                            "guaranteeNameEN",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "row.item.guaranteeNameEN"
                                                      }
                                                    })
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            2369172144
                                          )
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("b-table", {
                                          attrs: {
                                            striped: "",
                                            hover: "",
                                            items: _vm.appVo.requesterList,
                                            fields: _vm.fields
                                          }
                                        })
                                      ],
                                      1
                                    )
                              ])
                            ])
                          : _vm._e(),
                        _c(_vm.dynamicBene, {
                          tag: "component",
                          attrs: {
                            reqType: _vm.reqType,
                            appVo: _vm.appVo,
                            beneGroup: _vm.appVo.beneGroup,
                            lgFormNo: _vm.lgFormNoExtendTop,
                            beneTaxId: _vm.appVo.beneTaxId,
                            specificVo: _vm.specificVo,
                            lgSpecificFields: _vm.lgSpecificFields
                          },
                          on: { childToParent: _vm.onChildChange }
                        }),
                        _c("div", { staticClass: "form-row" }, [
                          _vm._m(6),
                          _vm._m(7),
                          _c(
                            "div",
                            { staticClass: "form-group no-label col-md-3" },
                            [
                              _c("date-picker", {
                                attrs: {
                                  name: "oldperiodStartDate",
                                  lang: "th",
                                  format: "DD/MM/YYYY",
                                  placeholder: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.oldperiodStartDate,
                                  callback: function($$v) {
                                    _vm.oldperiodStartDate = $$v
                                  },
                                  expression: "oldperiodStartDate"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._m(8),
                          _c(
                            "div",
                            { staticClass: "form-group no-label col-md-3" },
                            [
                              _c("date-picker", {
                                attrs: {
                                  lang: "th",
                                  format: "DD/MM/YYYY",
                                  placeholder: "",
                                  disabled: ""
                                },
                                model: {
                                  value: _vm.oldperiodEndDate,
                                  callback: function($$v) {
                                    _vm.oldperiodEndDate = $$v
                                  },
                                  expression: "oldperiodEndDate"
                                }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    ),
                    _c(_vm.dynamicBC, {
                      tag: "component",
                      attrs: {
                        reqType: _vm.reqType,
                        appVo: _vm.appVo,
                        lgType: _vm.lgType,
                        lgSpecificFields: _vm.lgSpecificFields
                      },
                      on: { childExtToParent: _vm.onChildExtChange }
                    }),
                    _vm._m(9),
                    _c(
                      "div",
                      {
                        staticClass: "collapse show",
                        attrs: {
                          id: "collapseOne",
                          "aria-labelledby": "headingOne",
                          "data-parent": "#accordion"
                        }
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "default-padding" },
                          [
                            _c(_vm.dynamicExtType, {
                              ref: "extendComponent",
                              tag: "component",
                              attrs: {
                                appVo: _vm.appVo,
                                reqType: _vm.reqType,
                                oldperiodEndDate: _vm.oldperiodEndDate
                              },
                              on: {
                                onChildExtIncChange: _vm.onChildExtIncChange
                              }
                            }),
                            _c(_vm.dynamicIncType, {
                              ref: "incComponent",
                              tag: "component",
                              attrs: {
                                appVo: _vm.appVo,
                                reqType: _vm.reqType,
                                commNo: _vm.commNo,
                                lgType: _vm.lgType,
                                oldperiodEndDate: _vm.oldperiodEndDate,
                                feeAmt: _vm.feeAmt
                              },
                              on: { onChildIncChange: _vm.onChildIncChange }
                            })
                          ],
                          1
                        )
                      ]
                    ),
                    _c("hr"),
                    _c("div", { staticClass: "default-padding" }, [
                      _vm._m(10),
                      this.appVo.bcFlagByComNo === "1" ||
                      this.bcFlagByComNo === "1"
                        ? _c("div", { staticClass: "form-row" }, [
                            _c(
                              "div",
                              { staticClass: "form-group col-md-6" },
                              [
                                _c("label", [_vm._v("ค่าธรรมเนียม(บาท)")]),
                                _c("vue-numeric", {
                                  staticClass: "form-control",
                                  attrs: {
                                    separator: ",",
                                    precision: 2,
                                    name: "feeAmt",
                                    readonly: ""
                                  },
                                  model: {
                                    value: _vm.feeAmt,
                                    callback: function($$v) {
                                      _vm.feeAmt = $$v
                                    },
                                    expression: "feeAmt"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      this.appVo.bcFlagByComNo === "1" ||
                      this.bcFlagByComNo === "1"
                        ? _c("div", { staticClass: "form-row" }, [
                            _c("div", { staticClass: "form-group col-md-6" }, [
                              _c("label", [
                                _vm._v("ตัดบัญชีค่าธรรมเนียมอัตโนมัติ")
                              ]),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.accNoFee,
                                    expression: "accNoFee"
                                  },
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: { required: true },
                                    expression: "{ required: true }"
                                  }
                                ],
                                staticClass: "form-control",
                                class: {
                                  input: true,
                                  "is-danger": _vm.errors.has("accNoFee")
                                },
                                attrs: {
                                  type: "text",
                                  name: "accNoFee",
                                  placeholder: "",
                                  readonly: ""
                                },
                                domProps: { value: _vm.accNoFee },
                                on: {
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.accNoFee = $event.target.value
                                  }
                                }
                              })
                            ]),
                            _c(
                              "div",
                              { staticClass: "form-group col-md-6" },
                              [
                                _c("label", [
                                  _vm._v("จำนวนเงินคงเหลือในบัญชี(บาท)")
                                ]),
                                _c("vue-numeric", {
                                  staticClass: "form-control",
                                  attrs: {
                                    separator: ",",
                                    precision: 2,
                                    name: "accBalFee",
                                    readonly: ""
                                  },
                                  model: {
                                    value: _vm.accBalFee,
                                    callback: function($$v) {
                                      _vm.accBalFee = $$v
                                    },
                                    expression: "accBalFee"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        : _vm._e(),
                      (this.appVo.bcFlag === "1" &&
                        this.appVo.bcFlagByComNo !== "1") ||
                      (this.appVo.bcFlag !== "1" && this.bcFlagByComNo !== "1")
                        ? _c("div", { staticClass: "form-row" }, [
                            _vm._v("\n             \n            "),
                            _c("span", { staticClass: "text-red" }, [
                              _vm._v(
                                "ค่าธรรมเนียมขั้นต่ำ 500 บาท หรือเป็นไปตามระเบียบธนาคาร"
                              )
                            ])
                          ])
                        : _vm._e()
                    ])
                  ],
                  1
                ),
                _vm._m(11),
                _c("div", {
                  staticClass: "collapse show",
                  attrs: {
                    id: "collapseOne",
                    "aria-labelledby": "headingOne",
                    "data-parent": "#accordion"
                  }
                }),
                _c("div", { staticClass: "card-body compact-padding" }, [
                  _c("div", { staticClass: "default-padding" }, [
                    _c(
                      "div",
                      { staticClass: "doctype-body" },
                      _vm._l(_vm.docTypeList, function(item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticClass: "default-padding",
                            attrs: { id: "docType" + index }
                          },
                          [
                            _c("p", [
                              item.mandatFlag === "Y"
                                ? _c(
                                    "span",
                                    { staticClass: "text-red result-bold" },
                                    [_vm._v("*")]
                                  )
                                : _vm._e(),
                              _vm._v(
                                "\n                " +
                                  _vm._s(item.docTypeDesc) +
                                  "\n              "
                              )
                            ]),
                            _c("vue-dropzone", {
                              ref: "myVueDropzone" + index,
                              refInFor: true,
                              attrs: {
                                id: "dropzone" + index,
                                options: _vm.dropzoneOptions,
                                destroyDropzone: false
                              },
                              on: {
                                "vdropzone-removed-file": _vm.imageRemoved,
                                "vdropzone-error": _vm.uploadError,
                                "vdropzone-processing": function($event) {
                                  return _vm.initUpload(
                                    "myVueDropzone" + index,
                                    item.docTypeId
                                  )
                                },
                                "vdropzone-success": _vm.successUpload
                              }
                            }),
                            _c("br"),
                            _c("br")
                          ],
                          1
                        )
                      }),
                      0
                    )
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "d-flex justify-content-center mt-4" },
                  [
                    _c(
                      "div",
                      { staticClass: "col-6 col-sm-5 col-lg-5 col-xl-4" },
                      [
                        _c("div", { staticClass: "cta-btn single-btn" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-lg btn-primary-ktb",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  return _vm.saveRequest()
                                }
                              }
                            },
                            [_vm._v("\n              บันทึก\n            ")]
                          )
                        ])
                      ]
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [
            _vm._v("ค้นหาข้อมูลหนังสือค้ำประกันเดิม")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-5" }, [
      _c("label", [_vm._v("ผู้รับผลประโยชน์(ผู้รับหนังสือค้ำประกัน)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-5" }, [
      _c("label", [_vm._v("ประเภทค้ำประกัน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-5" }, [
      _c("label", [_vm._v("รหัสแบบฟอร์มหนังสือค้ำประกัน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-5" }, [
      _c("label", [_vm._v("หมายเลขบัญชีวงเงิน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-5" }, [
      _c("label", [_vm._v("จำนวนเงินค้ำประกัน(บาท)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-3" }, [
      _c("label", [_vm._v("ระยะเวลาในการค้ำประกัน")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-2" }, [
      _c("label", [_vm._v("ตั้งแต่วันที่")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-group no-label col-md-1" }, [
      _c("label", [_vm._v("ถึงวันที่")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [
            _vm._v("ข้อมูลต่ออายุ และ/หรือ เพิ่มวงเงินค้ำประกัน")
          ])
        ])
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-row" }, [
      _c("div", { staticClass: "form-group col-md-6" }, [
        _c("label", [_vm._v("ค่าธรรมเนียม")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "card-header first-header card-expandable",
        attrs: {
          id: "headingOne",
          "data-toggle": "collapse",
          "data-target": "#collapseOne",
          "aria-expanded": "true",
          "aria-controls": "collapseOne"
        }
      },
      [
        _c("div", { staticClass: "title" }, [
          _c("i", { staticClass: "feather-icon icon-file-plus" }),
          _c("h5", { staticClass: "mb-0" }, [_vm._v("เอกสารประกอบเพิ่มเติม")])
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }